export default {
  title: 'Domena sklepu',
  description:
    'Sklepy internetowe restauracji mogą działać we własnej domenie zamiast pod wspólnym adresem — na przykład pizza-mario.zamowienia-twojamarka.pl. Dwa rekordy DNS dodaje się tylko raz; każda restauracja dodana później otrzymuje adres automatycznie.',
  read_only_description:
    'Domena, w której działają sklepy restauracji tego partnera. Tylko partner może ją podłączyć lub zmienić.',
  read_only_empty: 'Ten partner nie podłączył żadnej domeny sklepu.',
  not_connected: {
    label: 'Domena dla sklepów restauracji',
    hint: 'Własna domena lub subdomena, na przykład zamowienia-twojamarka.pl. Musi to być inna domena niż ta, w której działają aplikacje zespołu — nie jej subdomena.',
    placeholder: 'zamowienia-twojamarka.pl',
    connect: 'Podłącz',
  },
  status: {
    pending_dns: 'Oczekuje na DNS',
    active: 'Aktywna',
    failed: 'Wymagane działanie',
    disabled: 'Odłączona',
  },
  primary_badge: 'Główna',
  summary: {
    pending: 'Czekamy na rekordy DNS. Zwykle trwa to kilka minut, czasem kilka godzin.',
    failed:
      'Nie udało się potwierdzić wszystkich rekordów na czas. Należy poprawić rekord oznaczony poniżej i kliknąć Sprawdź ponownie — od tego momentu sprawdzamy od nowa.',
    failed_leave: 'Aby połączyć inną domenę, najpierw odłącz tę.',
    live: '{{host}} jest aktywna.',
    primary: 'Każda nowa restauracja automatycznie otrzymuje adres w tej domenie.',
    standby:
      'Ustaw ją jako główną, aby każda nowa restauracja otrzymywała ją automatycznie. Restauracje działające już w innej domenie pozostaną tam, gdzie są.',
    regressed:
      '{{host}} jest aktywna, ale jeden z rekordów poniżej nie jest już potwierdzany. Sklepy nadal działają — należy poprawić rekord u dostawcy DNS.',
  },
  instructions: {
    title: 'Jak dodać rekordy',
    step_provider:
      'Należy zalogować się tam, gdzie zarządzany jest DNS domeny {{root}} — zwykle u firmy, w której kupiono domenę.',
    step_add: 'Każdy rekord poniżej należy dodać dokładnie tak, jak pokazano: typ, nazwę i wartość.',
    step_check: 'Po zapisaniu należy kliknąć „{{button}}”. Sami również sprawdzamy na bieżąco.',
    tip_name:
      'Większość dostawców oczekuje w polu nazwy tylko części przed {{root}} — _foodamigos-verify i *. Pełna nazwa jest pokazana poniżej, dla dostawców, którzy jej wymagają.',
    tip_wildcard:
      'Rekord * kieruje każdy adres w domenie {{root}} do sklepów, więc nigdy nie trzeba dodawać rekordu dla każdej restauracji.',
    tip_existing:
      'Istniejące rekordy dla {{root}}, na przykład strony internetowej, poczty lub www, działają dalej: rekord * obsługuje tylko nazwy, które nie mają własnego rekordu. Jeśli {{root}} ma już rekord *, należy zastąpić go naszym.',
    tip_cloudflare:
      'W Cloudflare rekord CNAME należy ustawić na „Tylko DNS” (szara chmura), inaczej nie możemy go zobaczyć.',
  },
  records: {
    title: 'Dodaj te rekordy DNS dla {{root}} u dostawcy domeny',
  },
  example: 'Restauracja będzie wtedy pod adresem takim jak {{host}}.',
  example_label: 'twoja-restauracja',
  buttons: {
    check_again: 'Sprawdź ponownie',
    make_primary: 'Ustaw jako główną',
    unlink: 'Odłącz',
    retry: 'Spróbuj ponownie',
  },
  primary_unavailable: 'Dostępne, gdy domena będzie aktywna.',
  unlink_blocked_one:
    '{{count}} restauracja nadal działa w tej domenie. Przed odłączeniem należy przenieść ją do innej domeny.',
  unlink_blocked_few: '{{count}} restauracje są nadal na tej domenie. Przenieś je na inną domenę przed odłączeniem.',
  unlink_blocked_many: '{{count}} restauracji jest nadal na tej domenie. Przenieś je na inną domenę przed odłączeniem.',
  unlink_blocked_other:
    'Liczba restauracji nadal działających w tej domenie: {{count}}. Przed odłączeniem należy przenieść je do innej domeny.',
  unlink_confirm: {
    title: 'Odłączyć {{host}}?',
    description: '{{host}} można później podłączyć ponownie.',
    description_primary:
      'Nowe restauracje znów otrzymają adres we wspólnej domenie. {{host}} można później podłączyć ponownie.',
    ok: 'Odłącz',
  },
  toasts: {
    load_error: 'Nie udało się wczytać domeny sklepu',
    load_error_read_only: 'Nie udało się wczytać domeny sklepu tego partnera',
    connected: 'Domena podłączona — teraz dodaj rekordy poniżej',
    connect_failed: 'Nie udało się podłączyć domeny',
    check_started: 'Ponowne sprawdzanie…',
    check_failed: 'Nie udało się rozpocząć sprawdzania. Ponowna próba będzie możliwa za minutę.',
    primary_set: 'Nowe restauracje otrzymują teraz tę domenę',
    primary_failed: 'Nie udało się ustawić tej domeny jako głównej',
    unlinked: 'Domena odłączona',
    unlink_failed: 'Nie udało się odłączyć domeny',
    unlink_has_restaurants_one:
      '{{count}} restauracja nadal działa w domenie {{host}}: {{names}}. Przed odłączeniem należy przenieść ją do innej domeny.',
    unlink_has_restaurants_few:
      '{{count}} restauracje są nadal na {{host}}: {{names}}. Przenieś je na inną domenę przed odłączeniem.',
    unlink_has_restaurants_many:
      '{{count}} restauracji jest nadal na {{host}}: {{names}}. Przenieś je na inną domenę przed odłączeniem.',
    unlink_has_restaurants_other:
      'Liczba restauracji nadal działających w domenie {{host}}: {{count}} ({{names}}). Przed odłączeniem należy przenieść je do innej domeny.',
    gone: 'Domena {{host}} nie jest już podłączona — mogła zostać odłączona w innej karcie.',
  },
};
